import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../notification.service';
var PolicyCancellationDetailsComponent = /** @class */ (function () {
    function PolicyCancellationDetailsComponent(activatedRoute, router, notificationService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.notificationService = notificationService;
        this.isLoading = false;
        // Forzamos a recargar la ruta cuando cambian los parametros
        this.router.routeReuseStrategy.shouldReuseRoute = function () { return false; };
        if (this.activatedRoute.snapshot.params.notificationId) {
            this.isLoading = true;
            this.notificationService.getNotificationById(this.activatedRoute.snapshot.params.notificationId)
                .subscribe(function (x) {
                _this.isLoading = false;
                _this.data = x;
            }, function () {
                _this.isLoading = false;
            });
        }
    }
    PolicyCancellationDetailsComponent.prototype.ngOnInit = function () {
    };
    return PolicyCancellationDetailsComponent;
}());
export { PolicyCancellationDetailsComponent };
